import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'frequencyTransform',
})
export class FrequencyTransformPipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'DAILY':
        return 'Diario';
      case 'WEEKLY':
        return 'Semanal';
      case 'BIWEEKLY':
        return 'Bisemanal';
      case 'MONTHLY':
        return 'Mensual';
    }
    return '';
  }
}
